import type { Configuration, RedirectRequest } from '@azure/msal-browser';
import { getRuntimeConfigValue } from '@/lib/runtime-config';

const DEV_TENANT_ID = '4ead35c5-80e2-47f6-8f87-fc628b379c73';
const DEV_CLIENT_ID = '402e98d6-0593-4cfb-9e73-2f18eea36917';
const DEV_API_SCOPE = 'api://dev-saintz-backoffice-api/access_as_user';

function requireRuntimeValue(key: string): string {
  const value = getRuntimeConfigValue(key);
  if (value) {
    return value;
  }

  if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
    return key === 'VITE_BACKOFFICE_API_SCOPE'
      ? DEV_API_SCOPE
      : key === 'VITE_ENTRA_CLIENT_ID'
        ? DEV_CLIENT_ID
        : DEV_TENANT_ID;
  }

  throw new Error(`Missing ${key} runtime config for backoffice authentication.`);
}

export function getBackofficeAuthSettings() {
  const tenantId = requireRuntimeValue('VITE_ENTRA_TENANT_ID');
  const clientId = requireRuntimeValue('VITE_ENTRA_CLIENT_ID');
  const apiScope = requireRuntimeValue('VITE_BACKOFFICE_API_SCOPE');

  return {
    tenantId,
    clientId,
    apiScope,
    authority: `https://login.microsoftonline.com/${tenantId}`,
  };
}

export function getMsalConfig(): Configuration {
  const settings = getBackofficeAuthSettings();
  const origin = typeof window === 'undefined' ? 'http://localhost:5175' : window.location.origin;

  return {
    auth: {
      clientId: settings.clientId,
      authority: settings.authority,
      redirectUri: `${origin}/auth/callback`,
      postLogoutRedirectUri: `${origin}/logout`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
}

export function getBackofficeLoginRequest(): RedirectRequest {
  return {
    scopes: [getBackofficeAuthSettings().apiScope],
  };
}
